export default __webpack_public_path__ + "static/media/groupImg.9cb29a39.png";